import { FC, ReactNode } from 'react';
import { cn } from '@fe-learner-common/utils';

type PageProps = {
  children: ReactNode;
  className?: string;
};

export const Page: FC<PageProps> = ({ children, className }) => {
  return (
    <main
      className={cn(
        'px-3 py-6 2xl:container lg:px-8 lg:py-6 xl:px-[60px]',
        className,
      )}
    >
      {children}
    </main>
  );
};
